/* eslint-disable react/prop-types */

import React, { Component } from "react";
import $ from "jquery";

String.prototype.capitalize = function() {
  return this.charAt(0).toUpperCase() + this.slice(1);
};

export default class EducationFiltererMbo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hideNiveauFilterItem: props.niveau ? true : false,
      hideOpleidingsrichtingFilterItem: props.opleidingsrichting ? true : false,
      hideOpleidingFilterItem: props.opleidingstitel ? true : false,
      hideTypeFilterItem: props.type ? true : false,
      hideLocatieFilterItem: props.locatie ? true : false,
      opleidingsrichtingen: [],
      resetFilters: props.resetFilters
        ? props.resetFilters.split(",")
        : ["opleidingsrichting"],
      uniqueType: false,
      initialState: 0,
      filters: {
        opleidingsrichting: props.opleidingsrichting,
        opleidingstitel: props.opleidingstitel,
        niveau: props.niveau,
        type: props.type,
        locatie: props.locatie
      }
    };
  }

  componentDidMount() {
    this.getDefaultResults();
  }

  getDefaultResults() {
    $.ajax({
      url: "/wp-admin/admin-ajax.php?action=filter_education",
      data: this.state.filters,
      dataType: "json",
      success: response => {
        let nextState = this.state;
        nextState.results = response;

        nextState.opleidingsrichtingen = [
          ...new Set(response.map(item => item.opleidingsrichting).sort())
        ];

        let uniqueTypes = [...new Set(response.map(item => item.type))];
        if (uniqueTypes.length === 1) {
          let nextFilters = Object.assign({}, this.state.filters, {
            type: uniqueTypes[0]
          });
          nextState.hideTypeFilterItem = true;
          nextState.filters = nextFilters;
        }

        this.setState(nextState);
      }
    });
  }

  hasFilters(keys) {
    let filterValues = keys.map(key => this.state.filters[key]);
    return filterValues.every(item => typeof item !== "undefined");
  }

  uniqueLocaties() {
    if (typeof this.state.results === "undefined") {
      return [];
    }

    return [...new Set(this.state.results.map(item => item.locatie))];
  }

  uniqueNiveaus() {
    if (typeof this.state.results === "undefined") {
      return [];
    }

    return [...new Set(this.state.results.map(item => item.niveau))];
  }

  uniqueOpleidingen() {
    if (typeof this.state.results === "undefined") {
      return [];
    }

    return [
      ...new Set(this.state.results.map(item => item.opleidingstitel).sort())
    ];
  }

  uniqueOpleidingsrichtingen() {
    if (typeof this.state.results === "undefined") {
      return [];
    }
    return this.state.opleidingsrichtingen;

    let opleidingsrichtingen = [
      ...new Set(this.state.results.map(item => item.opleidingsrichting))
    ];
  }

  uniqueTypes() {
    if (typeof this.state.results === "undefined") {
      return [];
    }

    let results = [...new Set(this.state.results.map(item => item.type))];

    return results.sort();
  }

  renderTypeOptions() {
    return this.uniqueTypes().map(type => {
      let label = type.toUpperCase();

      if (type === "groeipunt") {
        label = "BBL Volwassenen";
      }

      if (type === "bolverkort") {
        label = "BOL verkort";
      }

      if (type === "bblverkort") {
        label = "BBL verkort";
      }

      if (type === "veluweplant") {
        label = "BBL VeluwePlant";
      }

      return (
        <option key={type} value={type}>
          {label}
        </option>
      );
    });
  }

  renderOpleidingsrichtingOptions() {
    return this.uniqueOpleidingsrichtingen().map(opleidingsrichting => {
      return <option key={opleidingsrichting}>{opleidingsrichting}</option>;
    });
  }

  renderOpleidingOptions() {
    return this.uniqueOpleidingen().map(opleiding => {
      return <option key={opleiding}>{opleiding}</option>;
    });
  }

  renderNiveauOptions() {
    return this.uniqueNiveaus().map(niveau => {
      return <option key={niveau}>{niveau}</option>;
    });
  }

  renderTypeFilterItem() {
    if (this.state.hideTypeFilterItem) {
      return null;
    }

    if (this.hasFilters(["opleidingstitel", "niveau"]) === false) {
      return null;
    }

    if (this.state.uniqueType) {
      return this.renderTypeFilterItemSingle();
    }

    let className = "filter__select filter__select--big";
    if (this.state.filters.type !== undefined) {
      className += " filter__select--active";
    }

    return (
      <li className="filter__item filter__item--type">
        <select
          value={this.state.filters.type}
          disabled={this.state.filters.type !== undefined}
          className={className}
          name="type"
          onChange={e => this.changeFilter("type", e.target.value)}
        >
          <option selected={this.state.filters.type === undefined} value="0">
            Type
          </option>
          {this.renderTypeOptions()}
        </select>
        {this.state.filters.type !== undefined && (
          <a
            className="filter__reset filter__reset--big"
            onClick={e => this.resetFilters(e)}
          >
            X
          </a>
        )}
      </li>
    );
  }

  renderTypeFilterItemSingle() {
    return (
      <li className="filter__item">
        <div className="filter__toggle__label filter__toggle__label--outline">
          Deze opleiding wordt alleen in de vorm{" "}
          <strong>{this.state.filters.type}</strong> aangeboden.
        </div>
      </li>
    );
  }

  renderLocatieOptions() {
    return this.uniqueLocaties().map(locatie => {
      return <option key={locatie}>{locatie}</option>;
    });
  }

  renderLocatieOptions() {
    return this.uniqueLocaties().map(locatie => {
      return <option key={locatie}>{locatie}</option>;
    });
  }

  changeFilter(key, value) {
    if (value === 0) {
      return;
    }

    let nextState = Object.assign({}, this.state);

    let nextFilters = {
      opleidingsrichting: this.state.filters.opleidingsrichting,
      opleidingstitel: this.state.filters.opleidingstitel,
      niveau: this.state.filters.niveau
    };

    if (key === "opleidingsrichting") {
      (nextFilters.opleidingsrichting = value),
        delete nextFilters.opleidingstitel;
      delete nextFilters.type;
      delete nextFilters.locatie;
      delete nextFilters.niveau;
      nextState.uniqueType = false;
    }

    if (key === "opleidingstitel") {
      let values = value.split(" niveau ");

      nextFilters.opleidingstitel = value;
      nextFilters.niveau = values[1];
    }

    if (key === "type") {
      nextFilters.type = value;
    }

    if (key === "locatie") {
      nextFilters.type = this.state.filters.type;
      nextFilters.locatie = value;
    }

    nextState.filters = nextFilters;
    this.setState(nextState);

    $.ajax({
      url: "/wp-admin/admin-ajax.php?action=filter_education",
      data: nextState.filters,
      dataType: "json",
      success: response => {
        nextState.results = response;

        if (this.state.filters.type === undefined) {
          let uniqueTypes = [...new Set(response.map(item => item.type))];
          if (uniqueTypes.length === 1) {
            let nextFilters = Object.assign({}, this.state.filters, {
              type: uniqueTypes[0]
            });
            nextState.uniqueType = true;
            nextState.filters = nextFilters;
          }
        }

        this.setState(nextState);
      }
    });
  }

  renderOpleidingsrichtingFilterItem() {
    if (this.state.hideOpleidingsrichtingFilterItem === true) {
      return null;
    }

    let className = "filter__select filter__select--big";
    if (this.state.filters.opleidingsrichting !== undefined) {
      className += " filter__select--active";
    }

    return (
      <li className="filter__item filter__item--opleiding">
        <select
          className={className}
          name="opleidingsrichting"
          onChange={e =>
            this.changeFilter("opleidingsrichting", e.target.value)
          }
        >
          <option
            selected={this.state.filters.opleidingsrichting === undefined}
            value="0"
          >
            Opleidingsrichting
          </option>
          {this.renderOpleidingsrichtingOptions()}
        </select>
      </li>
    );
  }

  renderOpleidingFilterItem() {
    if (this.state.hideOpleidingFilterItem === true) {
      return null;
    }

    if (this.hasFilters(["opleidingsrichting"]) === false) {
      return null;
    }

    let className = "filter__select filter__select--big";
    if (this.state.filters.opleidingstitel !== undefined) {
      className += " filter__select--active";
    }

    return (
      <li className="filter__item filter__item--opleiding">
        <select
          className={className}
          name="opleidingstitel"
          disabled={this.state.filters.opleidingstitel !== undefined}
          onChange={e => this.changeFilter("opleidingstitel", e.target.value)}
        >
          <option value="0">Niveau</option>
          {this.renderOpleidingOptions()}
        </select>
        {this.state.filters.opleidingstitel !== undefined && (
          <a
            className="filter__reset filter__reset--big"
            onClick={e => this.resetFilters(e)}
          >
            X
          </a>
        )}
      </li>
    );
  }

  renderLocatieFilterItem() {
    if (this.state.hideLocatieFilterItem === true) {
      return null;
    }

    if (this.hasFilters(["niveau", "type", "opleidingstitel"]) === false) {
      return null;
    }

    let className = "filter__select filter__select--big";
    if (this.state.filters.locatie !== undefined) {
      className += " filter__select--active";
    }

    return (
      <li className="filter__item filter__item--locatie">
        <select
          value={this.state.filters.locatie}
          disabled={this.state.filters.locatie !== undefined}
          className={className}
          name="locatie"
          onChange={e => this.changeFilter("locatie", e.target.value)}
        >
          <option selected={this.state.filters.locatie === undefined} value="0">
            Locatie
          </option>
          {this.renderLocatieOptions()}
        </select>
        {this.state.filters.locatie !== undefined && (
          <a
            className="filter__reset filter__reset--big"
            onClick={e => this.resetFilters(e)}
          >
            X
          </a>
        )}
      </li>
    );
  }

  resetFilters(e) {
    e.preventDefault();
    this.state.resetFilters.forEach(item => {
      this.changeFilter(item, undefined);
    });
  }

  resetAll(e) {
    e.preventDefault();
    window.location.reload(true);
  }

  renderButton() {
    if (
      typeof this.state.results === "undefined" ||
      this.state.results.length !== 1 ||
      this.state.filters.locatie === undefined
    ) {
      return (
        <a
          href="#"
          className="modal__button button button--bold button--icon button--icon-cta button--primary button--x-large button--is-disabled"
        >
          Inschrijven voor deze opleiding
        </a>
      );
    }

    let result = this.state.results[0];
    let type =
      result["type"] === "groeipunt" || result["type"] === "veluweplant"
        ? result["type"]
        : result["type"].toUpperCase();
    let crebo = result["crebo"];
    let locatie = result["locatie"];
    let suffix = result["suffix"];
    let link = result["link"];
    let short = result["short"];

    let url = link;

    if (type === "groeipunt") {
      let url = `${this.props.redirectUrl}?code=BBL${crebo}Groeipunt${suffix}`;
      return (
        <a
          href={url}
          className="modal__button button button--bold button--icon button--icon-cta button--primary button--x-large"
          target="_blank"
          rel="noreferrer"
        >
          Inschrijven voor deze opleiding
        </a>
      );
    }

    if (result["type"] === "veluweplant") {
      return (
        <a
          href={url}
          className="modal__button button button--bold button--icon button--icon-cta button--primary button--x-large"
          target="_blank"
          rel="noreferrer"
        >
          Inschrijven voor deze opleiding
        </a>
      );
    }

    return (
      <a
        href={url}
        className="modal__button button button--bold button--icon button--icon-cta button--primary button--x-large"
        target="_blank"
        rel="noreferrer"
      >
        Inschrijven voor deze opleiding
      </a>
    );
  }

  renderButtonReset() {
    if (this.props.showReset !== true) {
      return;
    }

    return (
      <a
        href="#"
        className="modal__button button button--bold button--secondary button--small"
        onClick={e => this.resetAll(e)}
      >
        Reset filter
      </a>
    );
  }

  render() {
    return (
      <div className="education-filterer">
        <ul className="filter filter--large filter--modal">
          {this.renderOpleidingsrichtingFilterItem()}

          {this.renderOpleidingFilterItem()}

          {this.renderTypeFilterItem()}

          {this.renderLocatieFilterItem()}
        </ul>

        <footer className="education-filterer__footer">
          {this.renderButton()}
          {this.renderButtonReset()}
        </footer>
      </div>
    );
  }
}
